<template>
    <sg-quick-pay-content>

        <router-view />
    </sg-quick-pay-content>

</template>

<script>
    import SgQuickPayContent from './SgQuickPayContent'

    export default {

        components: { SgQuickPayContent }, 

        created() {
            this.$eventBus.$on('error', error => {



                  this.$eventBus.$emit('modal:dialog', {
                dialogProps: {
                    noClickAnimation: true,
                    persistent: true,
                },
                props: {
                    message: "Неудалось выполнить запрос.",
                    acceptText: 'Ок',
                },
/*                 listeners: {
                    accept: () => {
                        this.$nextTick(() => {
                            this.$refs.phone.focus()
                        })
                    }
                } */
            })
            })
        }
    }
</script>

<style>

</style>